export default {
  conditions: [],
  conditionsLogic: '',
  conditionsForGlobalVars: [],
};
